import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const BORDER_COLOR = '#8A9EAF';
const BORDER_STYLE = 'solid';

const styles = StyleSheet.create({
  tableColFirstHeader: {
    width: 6 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 0,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopLeftRadius: 0,
    alignItems: 'center',
    height: '100%',
  },
  details__header__1: {
    width: 35 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
    height: '100%',
  },
  details__header: {
    width: 12 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
    height: '100%',
  },
  tableColFirstbody: {
    width: 6 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 0,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopLeftRadius: 0,
    alignItems: 'center',
    height: '100%',
    paddingTop: 5,
    paddingBottom: 5,
  },
  details__body__1: {
    width: 35 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
    height: '100%',
    paddingTop: 5,
    paddingBottom: 5,
  },
  details__body: {
    width: 12 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
    height: '100%',
    paddingTop: 5,
    paddingBottom: 5,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
    alignItems: 'center',
  },
  tableRowHead: {
    margin: 'auto',
    flexDirection: 'row',
    backgroundColor: 'rgba(231, 236, 244, .8)',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderBottomWidth: 0,
    borderRadius: 0,
    overflow: 'hidden',
    marginTop: 10,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  tableCell: {
    paddingTop: 0,
    paddingRight: 5,
    paddingLeft: 5,
    paddingBottom: 0,
    margin: 0,
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  tableCell__main: {
    paddingTop: 0,
    paddingRight: 5,
    paddingLeft: 5,
    paddingBottom: 0,
    margin: 0,
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '500',
  },
  tag: {
    padding: 7,
    paddingTop: 2,
    paddingBottom: 2,
    backgroundColor: 'rgba(231, 236, 244, .8)',
    fontSize: 6,
    fontFamily: 'Roboto',
    fontWeight: '400',
    borderRadius: '100px',
    textTransform: 'capitalize',
  },
  display__flex: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  item__num: {
    fontSize: 6,
    fontFamily: 'Roboto',
    fontWeight: '400',
    color: '#6D7D8B',
    marginRight: 5,
    marginLeft: 5,
    paddingTop: 2,
  },
  notes__main: {
    backgroundColor: 'rgba(231, 236, 244, .8)',
    borderBottomWidth: 1,
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    padding: 10,
  },
  note__heading: {
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '500',
    paddingBottom: 5,
  },
  note__text: {
    fontSize: 6,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
});

export default function Table({ items, currencySymbol, addCommasToNumber }) {
  return (
    <>
      <View style={styles.table}>
        <View style={styles.tableRowHead} wrap={false}>
          <View style={styles.tableColFirstHeader}>
            <Text style={styles.tableCellHeader}>Sr#</Text>
          </View>

          <View style={styles.details__header__1}>
            <Text style={styles.tableCellHeader}>Item Description</Text>
          </View>

          <View style={styles.details__header}>
            <Text style={styles.tableCellHeader}>Price</Text>
          </View>

          <View style={styles.details__header}>
            <Text style={styles.tableCellHeader}>QTY</Text>
          </View>

          <View style={styles.details__header}>
            <Text style={styles.tableCellHeader}>Discount</Text>
          </View>

          <View style={styles.details__header}>
            <Text style={styles.tableCellHeader}>Tax</Text>
          </View>
          <View style={styles.details__header}>
            <Text style={styles.tableCellHeader}>Total</Text>
          </View>
        </View>
        {items?.map((item, index) => {
          return (
            <View style={styles.tableRow} key={index++}>
              <View style={styles.tableColFirstbody}>
                <Text style={styles.tableCell}>{index + 1}</Text>
              </View>

              <View style={styles.details__body__1}>
                <View style={styles.display__flex}>
                  <Text style={styles.tableCell__main}>
                    {item?.description}{' '}
                  </Text>
                </View>

                <Text style={styles.item__num}>
                  {item?.type === 'parts_supplies' && item?.partSupplyNo ? (
                    <Text style={styles.item__num}>PR-{item.partSupplyNo}</Text>
                  ) : (
                    <Text style={styles.item__num} />
                  )}
                </Text>
              </View>

              <View style={styles.details__body}>
                <Text style={styles.tableCell}>
                  {currencySymbol}
                  {addCommasToNumber(
                    Math.round((+item?.price || 0) * 100) / 100 || 0,
                  )}
                </Text>
              </View>

              <View style={styles.details__body}>
                <Text style={styles.tableCell}>{item?.qty}</Text>
              </View>

              <View style={styles.details__body}>
                <Text style={styles.tableCell}>
                  {currencySymbol}
                  {addCommasToNumber(
                    Math.round((+item?.calculatedDiscount || 0) * 100) / 100 ||
                      0,
                  )}
                </Text>
              </View>

              <View style={styles.details__body}>
                <Text style={styles.tableCell}>
                  {currencySymbol}
                  {item?.isTax
                    ? addCommasToNumber(
                        Math.round((+item?.calculatedTax || 0) * 100) / 100 ||
                          0,
                      )
                    : 0}
                </Text>
              </View>

              <View style={styles.details__body}>
                <Text style={styles.tableCell}>
                  {currencySymbol}
                  {addCommasToNumber(
                    Math.round((+item?.total || 0) * 100) / 100 || 0,
                  )}
                </Text>
              </View>
            </View>
          );
        })}
      </View>
    </>
  );
}
